import { HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { JhiAlertService, JhiEventManager, JhiParseLinks } from 'ng-jhipster';
import { Subscription } from 'rxjs';
import { Principal } from 'src/app/core/auth/principal.service';
import { ITEMS_PER_PAGE } from 'src/app/shared/constants/pagination.constants';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { StorageDeclarationMySuffixService } from '../storage-insurance-declare-my-suffix/storage-insurance-declare-my-suffix.service';

@Component({
  selector: 'jhi-scope-my-storage-certificates',
  templateUrl: './scope-my-storage-certificates.component.html',
  styleUrls: []
})
export class ScopeMyStorageCertificatesComponent implements OnInit {


  storageDeclare = [];

  links: any;
  totalItems: any;
  queryCount: any;
  eventSubscriber: Subscription;
  routeData: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  pid: any;
  sid: any;
  lid: any;

  searchText: string;
  flag: boolean;
  showBackButton=false;

  storageDeclarationPermission:any
  constructor(
    private router: Router,
    public principal: Principal,
    private parseLinks: JhiParseLinks,
    private eventManager: JhiEventManager,
    private activatedRoute: ActivatedRoute,
    private jhiAlertService: JhiAlertService,
    private storageDeclarationService: StorageDeclarationMySuffixService,
    private languageChangeService: LanguageChangeService,

  ) {
    this.itemsPerPage = ITEMS_PER_PAGE;
    this.routeData = this.activatedRoute.data.subscribe(data => {
      this.page = data.pagingParams.page;
      this.previousPage = data.pagingParams.page;
      this.reverse = data.pagingParams.ascending;
      this.predicate = data.pagingParams.predicate;
      // if(this.itemsPerPage == 25 && this.page >1){
      //   this.page =1;
      // }
    });
    this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
          if (paramMap.get('size')) {
            this.itemsPerPage = paramMap.get('size')
          }
            const refresh = paramMap.get('refresh');
            if (refresh) {
                this.languageChangeService.refreshLanguage();
            }
    });
  }

  previousState() {
    window.history.back();
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(event => {
      this.pid = event.pid ? event.pid : null;
      this.sid = event.sid ? event.sid : null;
      this.lid = event.lid ? event.lid : null;
    });

    this.principal.setTitle("Storage Declaration");
    this.storageDeclarationPermission = this.principal.storageDeclaration;
    if (this.pid && (this.sid || this.lid)) {
      this.loadAll();
    }
  }
  sort() {
    const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }


  loadAll() {

    let url = null;
    if (this.pid && this.sid) {
      url = '/policy/' + this.pid + '/scope/' + this.sid
    } else {
      url = '/policy/' + this.pid + '/location/' + this.lid
    }

    this.storageDeclarationService
      .queryWithUrl(url, {
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort()
      })
      .subscribe(
        (res: HttpResponse<any[]>) => this.paginateDeclaration(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }

  private paginateDeclaration(data: any[], headers: HttpHeaders) {
    this.links = this.parseLinks.parse(headers.get('link'));
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.storageDeclare = data;
  }

  private onError(errorMessage: string) {
    this.jhiAlertService.error(errorMessage, null, null);
  }

  loadPage(page: number) {
    if (page !== this.previousPage) {
      this.previousPage = page;
      this.transition();
    }
  }

  transition() {
    this.router.navigate(['/scope-my-suffix/scope-my-storage-Insurance/' + this.pid + '/' + this.sid], {
      queryParams: {
        page: this.page,
        size: this.itemsPerPage,
        sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
      }
    });
    this.loadAll();
  }

  registerChangeInstorage() {
    this.eventSubscriber = this.eventManager.subscribe('declarationScopeStorage', response => this.loadAll());
  }

  onChange(value) {
    this.page = 0;
    this.itemsPerPage = value
    this.loadAll();
  }

  searchItems() {
    if (this.searchText) {
        var pNo = 0;
         var size = this.itemsPerPage;
        if (this.flag == true) {
            pNo = this.page - 1;
            size = this.itemsPerPage;
            this.flag = false;
        }
        var url='storage-declaration-request/policy/' + this.pid + '/location/' + this.lid+'/search';
        this.principal
            .searchQuery(this.searchText,url, {
                page: pNo,
                size: size,
                sort: this.sort()
            })
            .subscribe(
                (res: HttpResponse<any[]>) => this.paginateDeclaration(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    } else {
      this.loadAll();
    }

    
  }

}
